import { render, staticRenderFns } from "./Reciboestudiante.vue?vue&type=template&id=3b603480"
import script from "./Reciboestudiante.vue?vue&type=script&lang=js"
export * from "./Reciboestudiante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports